document.addEventListener("DOMContentLoaded", function() {

    // text area charecter counter 

    function troxy_count_enquiry(){
        // Get references to the textarea and character count element
        const textArea = document.getElementById('enquiry');
        const characterCount = document.getElementById('enquiryCounter');
 
        // Function to update the character count
        function updateCharacterCount() {
            const usedChars = textArea.value.length;
            characterCount.textContent = usedChars + '/1000';
 
            if(usedChars >= 1000) {
             characterCount.classList.add('invalid');
            } else {
             characterCount.classList.remove('invalid');
            }
        }
 
        // Add an event listener for the input event (when the user types)
        textArea.addEventListener('input', updateCharacterCount);
 
        // Initial update of character count
        updateCharacterCount();
     }
 
     if (document.getElementById('enquiry')) {
       troxy_count_enquiry();
     }
 
     // Form input fileds
     // On focus/click
 
     const inputs = document.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], textarea');
 
     if (inputs.length > 0) {
           // Add focus and blur event listeners to each input
       inputs.forEach(input => {
         input.addEventListener('focus', () => {
             // Hide the placeholder when focused
             input.setAttribute('data-placeholder', input.getAttribute('placeholder'));
             input.removeAttribute('placeholder');
         });
 
         input.addEventListener('blur', () => {
             // Restore the placeholder when blurred
             input.setAttribute('placeholder', input.getAttribute('data-placeholder'));
             input.removeAttribute('data-placeholder');
         });
       });
     }
 
     // END Inputs
});